module.exports = __webpack_public_path__ + "img/project.b31ebc5e.png";